import styled from 'styled-components';
export const WrapperPrintLabel = styled.div`
.page {
  flex-wrap: wrap;
  background: white;
  position: relative;
  display: block;
  align-items-center;
  margin-left: auto;
  margin-bottom: 0.2cm; //originally 0.5cm
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
  width: 10.8cm;
  height: 3.054cm;
  justify-content: space-between;
   page-break-after: always;
}
 
  
  .page:first-child {
    margin-top: 3px;
  }

  .page:last-child {
    // margin-bottom: -20px;
      page-break-after: avoid;
  }

  @media print {
    body {
      // width: 5.8cm;
      // height: 3.4cm;
      // margin: 0 auto;
      // height: 3.4cm;
    }
    
    #content {
    }
    .page {
    // height: 3.4cm;
      // position: absolute;
      // left: 0;
      // right: 0;
      // top: 0;
      // bottom: 0;
    // margin-top: 10px;
         margin-right: -45x;
         // margin-top: -65px;
      page-break-after: always;
    }
  }
`;
